<div class="custom_stepper" *ngIf="steps && steps.length > 0">
    <div class="custom_stepper_head">

        <ng-container *ngFor="let step of steps; let i = index">
            <div class="custom_stepper_head_item" (click)="headerStepNavigation(step, i)"
                [class.active_step]="activeStepIndex === i" [class.completed_step]="activeStepIndex > i"
                [ngClass]="{'header_nav_disabled': disableNavigation || i > activeStepIndex || i == activeStepIndex}">
                <div class="custom_stepper_item_indicator">{{i + 1}}</div>
                <div class="custom_stepper_head_item_details">
                    <div class="step_label">{{ step.title }}</div>
                </div>
            </div>
        </ng-container>

    </div>
    <div class="stepper-content p-2">

        <ng-container *ngIf="templates[activeStepIndex];">
            <ng-container *ngTemplateOutlet="templates[activeStepIndex]"></ng-container>
        </ng-container>

        <div class="col-lg-12 p-0">
            <ng-container *ngFor="let action of steps[activeStepIndex].actions">
                <ng-container>
                    <button *ngIf="action.value === 'back'" class="btn" [ngClass]="[action.color || 'btn-primary']"
                        (click)="handleStepsAction(steps[activeStepIndex], action)">
                        {{action.text}}
                    </button>
                </ng-container>
                <ng-container *ngIf="action.value !== 'back'">
                    <button class=" btn btn-submit float-end ms-2" [ngClass]="[action.color || 'btn-primary']"
                        (click)="handleStepsAction(steps[activeStepIndex], action)" [disabled]="action.submitted">
                        <span *ngIf="action.submitted" class="spinner-border spinner-border-sm me-2"></span>
                        <span *ngIf="!action.submitted">{{action.text}}</span>
                        <span *ngIf="action.submitted">Loading...</span>
                    </button>
                </ng-container>
            </ng-container>
        </div>

    </div>
</div>